export default __webpack_public_path__ + "static/bg-31be975cdc1fddd0665ed6c4f9e03a95.jpg";